import StringFormat from '../../utils/StringFormat'
import ApiManager from '../../utils/ApiManager'
import Constants from '../../utils/Constants'

const state = {
  loadingNews: false,
  newsItems: [],
  loadingSupport: false,
  supportHTML: null,
  user: '',
  message: {
    content: '',
    type: ''
  }
}

const actions = {
  async getInitData ({ dispatch, state, commit }, code) {
    commit('init')
    // dispatch('getSupportData')
    // dispatch('getNewsData')
    let type = 'success'
    // return userId to show on the page
    const response = await ApiManager.request('Password').passwordInput(code)
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
      commit('setUser', response.data.data.user_id)
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      type = 'error'
    }
    commit('setMessage', { content: response.data.data.message, type: type })
  },
  /**
   * お知らせデータ取得
   */
  async getNewsData ({ state, commit }) {
    commit('setNewsLoading', true)
    const response = await ApiManager.request('Notice').noticePublic()
    commit('setNews', response.data)
  },
  /**
   * サポートデータ取得 todo
   */
  getSupportData ({ state, commit }) {
    commit('setSupportHTML', null)
  },
  /**
   * パスワード変更完了
   */
  async complete ({ state, commit }, payload) {
    this.dispatch('loading/loadingPagePlus')
    const response = await ApiManager.request('Password').passwordComplete(payload)
    let type = 'success'
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      type = 'error'
    }
    commit('setMessage', { content: response.data.data.message, type: type })
    this.dispatch('loading/loadingPageMinus')
  }
}

const mutations = {
  init (state, data) {
    state.message = {
      content: '',
      type: ''
    }
  },
  setUser (state, data) {
    state.user = data
  },
  setMessage (state, data) {
    state.message = data
  },
  setNewsLoading (state, data) {
    state.loadingNews = data
  },
  setNews (state, data) {
    for (let i = 0; i < data.data.length; i++) {
      data.data[i].display_from = StringFormat.ymdhmFormat(data.data[i].display_from)
    }
    state.newsItems = data.data
    state.loadingNews = false
  },
  setSupportHTML (state, data) {
    state.supportHTML =
`
各種お問合せにつきましては、下記までご連絡をお願いします。<br>
<br>
■サポート受付時間<br>
月曜日〜金曜日 9:30〜17:00<br>
年末年始、及び祝祭日を除く。メールは随時受付しております。<br>
<br>
：03-6430-0723<br>
：eagleeye-s@truedata.co.jp<br>
<br>
尚、EagleEyeをご利用いただけるのは以下の時間帯となります。<br>
8:00〜23:00（日曜を除く）
`
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
